import { InspectionReportTemplate } from '../../admin/inspection-report-templates/inspection-report-template';
import { Drawing } from '../../idms/drawing';
import { Media } from '../../media/media';
import { IdmsType } from './idms-type';
import { InspectionReportHeaderInput } from './inspection-report-header-input';
import { InspectionReportInspectionPoint } from './inspection-report-inspection-point';
import { InspectionReportMeasurementInput } from './inspection-report-measurement-input';
import { InspectionReportObservationInput } from './inspection-report-observation-input';
import { InspectionReportTask } from './inspection-report-task';
import { InspectionReportWorkOrder, WorkOrder } from './inspection-report-work-order';
import { Inspector } from './inspector';
import { ApprovalStatus } from './report-approval-status';
import { ReportOrgTreeNode } from './report-org-tree-node';

export interface IWorkOrderReport {
  workOrders: WorkOrder[];
  id: string;
}

export interface ITaskReport {
  tasks: InspectionReportTask[];
  availableTasks: InspectionReportTask[];
  isErpEnabledForSite: boolean;
}

export interface IInspectionPointReport {
  inspectionPoints: InspectionReportInspectionPoint[];
  availableInspectionPoints: InspectionReportInspectionPoint[];
}

export interface IHierarchySelectionParent {
  orgTreeNodeId: string;
  hierarchyItem: ReportOrgTreeNode;
  site: ReportOrgTreeNode;
  idmsType: IdmsType;
}

export abstract class InspectionReportBase implements IWorkOrderReport, ITaskReport, IHierarchySelectionParent {
  inspectionReportId: string;
  description: string;
  inspectionDate: Date;
  reportNumber: any;

  inspectionConfidence: string;
  inspectionConfidenceId: string;

  orgTreeNodeId: string;
  hierarchyItem: ReportOrgTreeNode;

  inspectorId: string;
  inspector: Inspector;
  migrationInspector: string;

  templateId: string;
  template: InspectionReportTemplate;

  assetFamilyName: string;
  site: ReportOrgTreeNode;
  workOrders: InspectionReportWorkOrder[] = [];

  tasks: InspectionReportTask[] = [];
  availableTasks: InspectionReportTask[] = [];

  headers: InspectionReportHeaderInput[] = [];
  observations: InspectionReportObservationInput[] = [];
  measurements: InspectionReportMeasurementInput[] = [];
  isErpEnabledForSite: boolean;
  drawings: Drawing[] = [];

  idmsType: IdmsType;

  status: ApprovalStatus;


  get id() {
    return this.inspectionReportId;
  }

  media: Media[] = [];

  lastModifiedBy: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.inspectionReportId = data.inspectionReportId;
    this.description = data.description;
    this.inspectionDate = data.inspectionDate;
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.isErpEnabledForSite = data.isErpEnabledForSite;

    this.inspectionConfidence = data.inspectionConfidence;
    this.inspectionConfidenceId = data.inspectionConfidenceId;
    this.migrationInspector = data.migrationInspector;

    if (data.orgTreeNode) {
      this.hierarchyItem = new ReportOrgTreeNode();
      this.hierarchyItem.loadFromJson(data.orgTreeNode);
    }

    if (data.inspector) {
      this.inspector = new Inspector();
      this.inspectorId = data.inspectorId;
      this.inspector.loadFromJson(data.inspector);
    }

    if (data.site) {
      this.site = new ReportOrgTreeNode();
      this.site.loadFromJson(data.site);
    }

    if (data.workOrders) {
      data.workOrders.forEach(workOrder => {
        const newWorkOrder = new InspectionReportWorkOrder();
        newWorkOrder.loadFromJson(workOrder);
        this.workOrders.push(newWorkOrder);
      });
    }

    if (data.tasks) {
      data.tasks.forEach(task => {
        const newTask = new InspectionReportTask();
        newTask.loadFromJson(task);
        this.tasks.push(newTask);
      });
    }

    if (data.availableTasks) {
      data.availableTasks.forEach(task => {
        const newTask = new InspectionReportTask();
        newTask.loadFromJson(task);
        this.availableTasks.push(newTask);
      });
    }

    if (data.media) {
      this.media = [];
      data.media.forEach(item => {
        const newMedia = new Media();
        newMedia.loadFromJson(item);
        this.media.push(newMedia);
      });
    }

    this.drawings = [];
    if (data.drawings) {
      data.drawings.forEach(drawing => {
        const newDrawing = new Drawing();
        newDrawing.loadFromJson(drawing);
        this.drawings.push(newDrawing);
      });
    }
    if (data.status !== null) {
      this.status = data.status;
    }
    if (data.lastModifiedBy) {
      this.lastModifiedBy = data.lastModifiedBy;
    }
  }
}
